import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { ConsultationSummaryResponse } from './useConsultationSummary.types';

const PREFIX = '[consultationSummaryQuery]';

export const queryConsultationSummary = async (consultationId: number) => {
  console.log(PREFIX, `Fetching consultation #${consultationId}...`);
  const response = await CONSULTATIONS_ENDPOINTS.consultationSummary(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultation #${consultationId}.`);
  return json as ConsultationSummaryResponse;
};
